<template>
  <div class="appNav-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item title="弹出框地址" name="1">
          <el-input style="width: 100%" v-model="iframelinkUrlVal" placeholder="请输入http://或https://开头的地址"></el-input>
          <cx-check-box class="mt16" :value.sync="useSelfQuery">开启动态传参</cx-check-box>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
export default {
  name: "dialog-options-data",
  props: { options: Object },
  data() {
    return {
      activeNames: ["1"],
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    iframelinkUrlVal:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "iframelinkUrlVal", "iframelinkUrlVal", 'https://www.chaoxing.com/')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iframelinkUrlVal", false)
      }
    },
    useSelfQuery:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "useSelfQuery", "useSelfQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "useSelfQuery", false)
      }
    },
  },
  mounted(){
    this.removeSettingDataHandle();
  },
  methods: {
    removeSettingDataHandle:function(){
      let settingList = $(this.$el).parents('.text-options-data-dialog').find('.el-collapse-item');
      settingList.each(function(index,item){
        const itemName = $(item).find('.el-collapse-item__header').text();
        if(itemName==='链接地址') {
          $(item).hide();
        }
      })
    }
  }
}
</script>

<style scoped >

</style>
